/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Shop_Ocop_Stars_InvalidInputs */

const vi_error_shop_ocop_stars_invalid = /** @type {(inputs: Error_Shop_Ocop_Stars_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số sao OCOP từ 1 đến 5.`)
};

/**

* @param {Error_Shop_Ocop_Stars_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_shop_ocop_stars_invalid = /** @type {((inputs?: Error_Shop_Ocop_Stars_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Shop_Ocop_Stars_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_shop_ocop_stars_invalid(inputs)
});